import { Skeleton } from "@mui/material";

export function DashboardChartLoading() {

    return (
        <>
            <Skeleton 
                variant="rounded" 
                width='100%'
                height='70%'
            />
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
        </> 
    );
}
